import React, { useCallback } from 'react'
import { useContainerWidth, BillboardButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { SocialMenu } from '@fs/zion-social'
import { PersonAdd } from '@fs/zion-icon'
import { trackEvent } from '@fs/zion-analytics'
import { splunk } from '@fs/zion-splunk-logger'
import { appPath } from '@fs/zion-config'
import { createInvitation } from '../../services'

export default function GroupInviteButton({
  familyGroup,
  buttonText,
  buttonProps = {
    emphasis: 'high',
    color: 'blue',
  },
  socialMenuProps = {
    billboardButtonColor: 'blue',
    buttonEmphasis: 'high',
    color: 'blue',
  },
  socialMenuAnalytics,
  showIcon = true,
  event_name,
}) {
  const atWidth = useContainerWidth()
  const { t } = useTranslation()

  socialMenuProps.buttonText = buttonText ?? t('groups.invite-group-members', 'Invite Group Members*')
  socialMenuProps.hideIcon = !showIcon

  const inviteButtonText =
    buttonText ??
    atWidth({
      default: t('groups.invite', 'Invite*'),
      lg: t('groups.invite-group-members', 'Invite Group Members*'),
    })

  const triggerNativeShare = useCallback(
    ({ familyGroupId, inviteId }) => {
      navigator
        .share({
          title: t('groups.invitation.title', 'You are invited!*'),
          text: t('groups.invitation.message', 'Join My Family Group in Together By FamilySearch!*'),
          url: `${appPath}/invitation?groupId=${familyGroupId}&inviteId=${inviteId}`,
        })
        .then(() => splunk.log('Successful native share'))
        .catch((error) => splunk.log('Error sharing:', error))
    },
    [t]
  )

  const handleInviteClick = useCallback(() => {
    trackEvent({ event_name })
    createInvitation(familyGroup?.id)
      .then((response) => {
        const data = response?.data || {}
        const { inviteId, groupId: familyGroupId } = data
        if (inviteId && familyGroupId) {
          triggerNativeShare({ familyGroupId, inviteId })
        } else {
          console.error('Invalid inviteId or familyGroupId:', { inviteId, familyGroupId })
        }
      })
      .catch((error) => {
        console.error('Error creating invitation:', error)
      })
  }, [familyGroup?.id, triggerNativeShare, event_name])

  const getShareUrl = useCallback(() => {
    return new Promise((resolve) => {
      createInvitation(familyGroup?.id).then((response) => {
        const inviteId = response?.data?.inviteId
        resolve(`${appPath}/invitation?groupId=${familyGroup?.id}&inviteId=${inviteId}`)
      })
    })
  }, [familyGroup?.id])

  return (
    <>
      {navigator?.share && !/Macintosh/.test(navigator.userAgent) ? (
        <BillboardButton {...buttonProps} onClick={handleInviteClick} Icon={showIcon && PersonAdd}>
          {inviteButtonText}
        </BillboardButton>
      ) : (
        <SocialMenu
          Icon={showIcon ? PersonAdd : null}
          {...socialMenuProps}
          sharable={{
            url: getShareUrl,
            subject: 'subject',
            message: 'message',
          }}
          inline={false}
          analytics={socialMenuAnalytics}
        />
      )}
    </>
  )
}
